var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('date-range-select',{attrs:{"ranges":_vm.ranges,"opens":_vm.opens,"placeholder":_vm.placeholder,"input-class":_vm.inputClass},model:{value:(_vm.dateRange),callback:function ($$v) {_vm.dateRange=$$v},expression:"dateRange"}})
}
var staticRenderFns = []

export { render, staticRenderFns }